var __rspack_ns_object = JSON.parse('{"status":400,"error":"Bad Request","message":"Recaptcha score is lower than threshold"}')